import { render, staticRenderFns } from "./ActivityItem.vue?vue&type=template&id=5a85e968&scoped=true&"
import script from "./ActivityItem.vue?vue&type=script&lang=ts&"
export * from "./ActivityItem.vue?vue&type=script&lang=ts&"
import style0 from "./ActivityItem.vue?vue&type=style&index=0&id=5a85e968&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a85e968",
  null
  
)

export default component.exports